export var trackEvent = function (eventName, params) {};